export const DELETION_AR = {
  title: "حذف الحساب والبيانات",
  version: "2.0",
  updated: "2026-06-12",
  intro:
    "هذه الصفحة توضّح كيف تحذف حسابك في HELCOO وبياناتك، داخل التطبيق أو بطلب مباشر، وما يُحذف فوراً وما يُحتفظ به نظاماً. هذه الصفحة متاحة للعموم دون تسجيل دخول، استجابةً لمتطلب Google Play بشأن رابط حذف الحساب ولمتطلبات آبل بشأن الحذف من داخل التطبيق.",
  sections: [
    {
      h: "1. الحذف من داخل التطبيق (الطريقة المباشرة)",
      p: [
        "افتح التطبيق ← سجّل الدخول ← «الإعدادات» ← «حذف الحساب والبيانات» ← أكّد العملية.",
        "يُنفَّذ الحذف فوراً وبلا مراجعة بشرية ولا انتظار: تُحذف بصمة الوجه والصور المرجعية، وتُبطَل كل جلساتك على كل الأجهزة، ويُعطَّل الحساب نهائياً ولا يمكن تسجيل الدخول به.",
        "العملية غير قابلة للتراجع. لا يمكن استعادة الحساب بعد تأكيد الحذف.",
      ],
    },
    {
      h: "2. الحذف بطلب مباشر (بدون تطبيق)",
      p: [
        "راسلنا من بريدك المسجَّل على support@helcoo.uk وبعنوان «حذف الحساب»، مع ذكر اسم شركتك.",
        "نتحقق من هويتك ثم ننفّذ الحذف خلال 30 يوماً كحد أقصى (وعادة خلال يومي عمل)، ونرسل لك تأكيداً كتابياً.",
      ],
    },
    {
      h: "3. ما يُحذف فوراً",
      p: [
        "بصمة الوجه والقالب الرقمي وكل الصور المرجعية · صورة الملف الشخصي · رموز الجهاز للإشعارات · كل جلسات الدخول ورموز الاستعادة · بيانات الاتصال الشخصية (الهاتف والعنوان وجهة الاتصال للطوارئ).",
      ],
    },
    {
      h: "4. ما قد يُحتفظ به ولماذا",
      p: [
        "سجلات الحضور والرواتب والإجازات والعقوبات والمستندات المالية تبقى في حساب صاحب العمل لأنها سجلات عمل ومحاسبية يُلزم القانون بالاحتفاظ بها (عادة 5–10 سنوات حسب بلد الشركة)، وهي مملوكة لصاحب العمل بصفته المتحكم بالبيانات.",
        "تُجرَّد هذه السجلات من معرّفاتك الشخصية القابلة للحذف (تُستبدل بالرقم المرجعي للسجل)، ولا تُستخدم لإعادة تحديد هويتك.",
        "سجلات الأمان والتدقيق تُحفظ لمدة محدودة لمنع الاحتيال والامتثال القانوني، ثم تُحذف تلقائياً.",
      ],
    },
    {
      h: "5. حذف بيانات الشركة بالكامل",
      p: [
        "إن كنت مدير الشركة وترغب بحذف حساب الشركة وكل بيانات موظفيها، راسل support@helcoo.uk من البريد المسجَّل للمدير.",
        "تُمنح الشركة 30 يوماً لتصدير بياناتها، ثم تُحذف كل البيانات نهائياً من قواعد البيانات والنسخ الاحتياطية وفق دورة النسخ المعتمدة (حتى 35 يوماً إضافية للنسخ الاحتياطية).",
      ],
    },
    {
      h: "6. إلغاء الاشتراك ليس حذفاً",
      p: [
        "إلغاء الاشتراك يوقف الفوترة والخدمة لكنه لا يحذف البيانات تلقائياً. لحذف البيانات يجب تقديم طلب الحذف صراحةً كما هو موضح أعلاه.",
      ],
    },
  ],
};
